import { useQueries } from "@tanstack/react-query";
import { useMemo } from "react";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../../../../../consts/api";
import { http } from "../../../../../../services/HttpService";

export function useBoomrxStatusByClinic(clinicIds) {
  const uniqueClinicIds = useMemo(
    () => [...new Set((clinicIds || []).filter(Boolean))],
    [clinicIds],
  );

  const results = useQueries({
    queries: uniqueClinicIds.map((clinicId) => ({
      queryKey: [QUERY_KEYS.boomrx.status, clinicId],
      queryFn: () =>
        http.get(HTTP_ENDPOINTS.boomrx.status(), { params: { clinicId } }),
      select: (res) => res?.data?.data?.enabled === true,
      staleTime: 5 * 60 * 1000,
    })),
  });

  return useMemo(
    () =>
      uniqueClinicIds.reduce((statusByClinic, clinicId, index) => {
        statusByClinic[clinicId] = results[index]?.data === true;
        return statusByClinic;
      }, {}),
    [results, uniqueClinicIds],
  );
}
